<template lang="html">
  <section class="c-loader">
    <p>loading</p>
    <p>{{this.progressSerialized}}</p>
  </section>
</template>

<script>
import {mapGetters} from 'vuex'

import AssetsLoader from 'assets-loader'
import { TweenLite, Power2 } from 'gsap'

export default {
  data () {
    return {
      progress: 0
    }
  },
  computed: {
    ...mapGetters([
      'loaded'
    ]),
    progressSerialized () {
      return (this.progress * 100).toFixed() + '%'
    }
  },
  methods: {
    hide () {
      TweenLite.to(this.$el, 0.35, {
        autoAlpha: 0,
        ease: Power2.easeInOut,
        onComplete: () => {
          this.$store.dispatch('setLoaded', true)
          this.$destroy()
        }
      })
    }
  },
  mounted () {
    let self = this

    new AssetsLoader({
      assets: [
        {url: 'static/img/projects/voices.jpg', type: 'jpg'},
        {url: 'static/img/projects/domingo.jpg', type: 'jpg'},
        {url: 'static/img/projects/life-ride.jpg', type: 'jpg'},
        {url: 'static/img/projects/gotaga.jpg', type: 'jpg'},
        {url: 'static/img/projects/zerator.jpg', type: 'jpg'},
        {url: 'static/img/projects/serre-chevalier.jpg', type: 'jpg'},
        {url: 'static/img/pp.png', type: 'png'}
      ]
    })
    .on('progress', function (progress) {
      self.progress = progress
    })
    .on('complete', function (map) {
      setTimeout(() => {
        self.hide()
      }, 250)
    })
    .start()
  }
}
</script>

<style lang="scss">
@import "../../vars.scss";

.c-loader {
  position: absolute;
  z-index: 200;
  display: flex;
  flex-direction: column;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: $dark;

  p {
    align-self: center;
    margin: 2px 0;
    color: $white;
    font-family: $proxima;
    font-weight: 800;
    font-size: 20px;

    &:last-child {
      color: $orange;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Loader.vue?150db750